import { Link } from "react-router-dom";

const capabilities = [
  {
    title: "AI-Powered Analysis",
    description:
      "Run intelligent financial analysis with role-based controls, organization scoping, and auditable workflows.",
  },
  {
    title: "Multi-Source Ingestion",
    description:
      "Ingest market, filing, and related financial signals into a unified platform for faster decisions.",
  },
  {
    title: "Reports and Insights",
    description:
      "Generate actionable insights and reports with traceable data lineage and consistent governance.",
  },
  {
    title: "Secure Team Access",
    description:
      "Use email/password and OAuth with RBAC permissions for admins, managers, analysts, and viewers.",
  },
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 via-white to-white text-gray-900">
      <header className="border-b border-indigo-100 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-lg bg-indigo-600 text-white grid place-items-center font-bold">
              FA
            </div>
            <div>
              <p className="text-sm font-semibold">Financial AI Analyst</p>
              <p className="text-xs text-gray-500">Intelligent Financial Platform</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-50"
            >
              Login
            </Link>
            <Link
              to="/signup"
              className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
            >
              Get Started
            </Link>
          </div>
        </div>
      </header>

      <main>
        <section className="mx-auto max-w-7xl px-6 py-16 md:py-20">
          <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <p className="mb-4 inline-flex rounded-full bg-indigo-100 px-3 py-1 text-xs font-semibold text-indigo-700">
                Platform Overview
              </p>
              <h1 className="text-4xl font-bold tracking-tight md:text-5xl">
                Complete financial intelligence for modern teams
              </h1>
              <p className="mt-6 max-w-2xl text-lg text-gray-600">
                Explore a full-stack platform for ingesting data, running AI-driven analysis,
                managing users with RBAC, and delivering reports through a production-ready workflow.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <Link
                  to="/signup"
                  className="rounded-lg bg-indigo-600 px-5 py-3 text-sm font-semibold text-white hover:bg-indigo-700"
                >
                  Create Account
                </Link>
                <Link
                  to="/login"
                  className="rounded-lg border border-gray-300 px-5 py-3 text-sm font-semibold hover:bg-gray-50"
                >
                  Sign In
                </Link>
              </div>
            </div>

            <div className="rounded-2xl border border-indigo-100 bg-white p-6 shadow-sm">
              <h2 className="text-lg font-semibold">What you get</h2>
              <ul className="mt-4 space-y-3 text-sm text-gray-700">
                <li className="rounded-lg bg-gray-50 px-4 py-3">
                  End-to-end analysis workflow from ingestion to reporting
                </li>
                <li className="rounded-lg bg-gray-50 px-4 py-3">
                  OAuth and local authentication with secure token flow
                </li>
                <li className="rounded-lg bg-gray-50 px-4 py-3">
                  Organization-aware access control and admin governance
                </li>
                <li className="rounded-lg bg-gray-50 px-4 py-3">
                  Scalable API and frontend deployment for team usage
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-6 pb-20">
          <h2 className="text-2xl font-bold">Core Capabilities</h2>
          <div className="mt-6 grid gap-5 md:grid-cols-2">
            {capabilities.map((item) => (
              <article
                key={item.title}
                className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm"
              >
                <h3 className="text-lg font-semibold">{item.title}</h3>
                <p className="mt-2 text-sm text-gray-600">{item.description}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
